export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M4 20h16V4H4zM4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm5 5.5a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 9 7.5M18 6l-5 5-2-2-5 5h12zM8 17.822h8v-1.5H8z\"/>"
};